import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_football-training-37/artifacts/wwzawrg6_photo%20jeremy%20fond%20site%20.png";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Jérémy Aymes"
          className="w-full h-full object-cover object-[65%_30%] scale-[1.4]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20" />
      </div>

      {/* Main content */}
      <div className="relative z-10 px-6 md:px-12 max-w-7xl mx-auto pt-32 md:pt-40 pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-9"
          >
            <h1
              className="font-display text-[18vw] sm:text-[14vw] lg:text-[10vw] leading-[0.9] tracking-tight"
              data-testid="hero-title"
            >
              <span className="block">GOALKEEPER</span>
              <span className="block text-[#CCFF00]">COACHING</span>
              <span className="block text-stroke">PAR JÉRÉMY AYMES</span>
            </h1>
          </motion.div>
        </div>

        {/* Bottom band */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="md:col-span-6"
          >
            <p className="text-zinc-300 text-base md:text-lg leading-relaxed max-w-xl">
              Ancien gardien professionnel <span className="text-white font-semibold">(National&nbsp;&amp;&nbsp;Ligue&nbsp;2)</span>, je
              transmets 15+ ans d&apos;expérience à travers un coaching individuel,
              technique et mental — du jeune gardien au niveau national.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="md:col-span-6 flex flex-wrap gap-4 md:justify-end"
          >
            <a
              href="#booking"
              data-testid="hero-cta-book"
              className="group inline-flex items-center gap-3 bg-[#CCFF00] text-black font-bold uppercase tracking-wide text-sm px-7 py-4 rounded-sm hover:bg-white transition-colors"
            >
              Réserver une séance
              <ArrowDownRight className="w-4 h-4 group-hover:translate-x-1 group-hover:translate-y-1 transition-transform" />
            </a>
            <a
              href="#about"
              data-testid="hero-cta-about"
              className="inline-flex items-center gap-3 border border-white/30 text-white font-bold uppercase tracking-wide text-sm px-7 py-4 rounded-sm hover:bg-white/5 transition-colors"
            >
              Découvrir mon parcours
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-6 md:left-12 z-10 flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
        <span className="w-px h-8 bg-zinc-600" />
        Scroll
      </div>
    </section>
  );
}
